export const DAYS_PRESETS = [
  { label: '7 days', value: 7 },
  { label: '30 days', value: 30 },
  { label: '60 days', value: 60 },
  { label: '90 days', value: 90 },
];

export const DEBUG_OUTCOME_COLORS = {
  COUNTED: { bg: '#e8f5e9', color: '#2e7d32' },
  RECOVERED: { bg: '#e0f2f1', color: '#00695c' },
  STREAK_BREAK: { bg: '#ffebee', color: '#c62828' },
  DUPLICATE_ALREADY_COUNTED: { bg: '#fff8e1', color: '#f57f17' },
  DUPLICATE_SAME_DAY: { bg: '#f5f5f5', color: '#616161' },
  OUT_OF_ORDER: { bg: '#f5f5f5', color: '#616161' },
  DAILY_FAIL_SAFE_INSERT: { bg: '#e3f2fd', color: '#1565c0' },
  FAIL_SAFE_APPLIED: { bg: '#e3f2fd', color: '#1565c0' },
};

export const STATUS_COLORS = {
  ok: { bg: '#e8f5e9', color: '#2e7d32' },
  issue: { bg: '#fff3e0', color: '#e65100' },
  inactive: { bg: '#f5f5f5', color: '#757575' },
};

export const ISSUE_TYPE_COLORS = {
  DUPLICATE_BLOCKED_STREAK: { bg: '#fff8e1', color: '#f57f17' },
  DAILY_WITHOUT_APP_VISIT: { bg: '#fce4ec', color: '#c2185b' },
  APP_VISIT_WITHOUT_STREAK_COUNT: { bg: '#fff3e0', color: '#e65100' },
  STREAK_BREAK: { bg: '#ffebee', color: '#c62828' },
  GAP_IN_DAILY_ACTIVITY: { bg: '#f3e5f5', color: '#6a1b9a' },
  STATE_LAGGING_BEHIND_DAILY: { bg: '#e8eaf6', color: '#283593' },
};

export function formatDateTime(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString();
}

export function formatJson(value) {
  if (value == null) return '—';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function isFalseBreakPattern(day) {
  const firstType = day?.events?.firstEventType;
  return (
    day?.dailyActivity?.exists &&
    firstType &&
    firstType !== 'APP_VISIT' &&
    firstType !== 'app_open'
  );
}

export function getOutcomeStyle(outcome) {
  if (!outcome) return { bg: '#fafafa', color: '#9e9e9e' };
  return DEBUG_OUTCOME_COLORS[outcome] || { bg: '#f5f5f5', color: '#424242' };
}

export function getStatusStyle(status) {
  return STATUS_COLORS[status] || { bg: '#f5f5f5', color: '#424242' };
}

export function getIssueTypeStyle(issueType) {
  return ISSUE_TYPE_COLORS[issueType] || { bg: '#f5f5f5', color: '#424242' };
}
